import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import ViewIcon from "../../../components/Icons/ViewIcon";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  saveActiveLeaveRequestsTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";

export default function AdminLeaveRequest() {
  const timeoutId = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const ActiveTab = useSelector((state) => state?.root?.activeLeaveRequestsTab);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: "",
    searchQuery: "",
    startDate: "",
    endDate: "",
    leaveList: [],
    leaveTypeList: [],
    staffType: ActiveTab == "2" ? "0" : "1",
    myLeave: "false",
    siteId: filterDetails?.siteId,
    officeType: "",
    leaveType: "",
    leaveStatus: "",
    siteList: [],
    officeList: [],
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    isInitial: true,
    isLoadingSite: false,
  });

  useEffect(() => {
    GetSiteList(ActiveTab);
    getLeaveSetting();
  }, []);

  useEffect(() => {
    GetLeaveReq();
  }, [
    pageStates?.currentPage,
    pageStates?.staffType,
    pageStates?.leaveType,
    pageStates?.leaveStatus,
    pageStates?.searchQuery,
    filterDetails?.siteId,
    pageStates?.officeType,
    pageStates?.sortByDate,
    pageStates?.pageSize,
    filterDetails?.orderBy,
  ]);

  const GetLeaveReq = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_leave +
      "?" +
      MainFilterHandler({
        ...pageStates,
        orderBy: filterDetails?.orderBy,
        siteId: pageStates.activeTab == 1 ? "" : pageStates?.siteId,
      });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.leave?.map((item) => ({
          ...item,
          employeeCode: item?.user?.employeeCode,
          empNameWithImage: item?.user?.name + "##" + item?.user?.profilePhoto,
          employeeDept: item?.user?.department?.name,
          officeName: item?.user?.site?.name,
          siteName: item?.user?.usersites?.[0]?.site?.name,
          appliedOn: moment(item?.createdAt).format("DD/MM/YYYY"),
          fromDate: moment(item.startDate).format("DD/MM/YYYY"),
          toDate: moment(item.endDate).format("DD/MM/YYYY"),
          days: moment(item.endDate).diff(moment(item.startDate), "days") + 1,
          leaveStatus: item?.status,
        }));
        setPageStates((pre) => ({
          ...pre,
          leaveList: newData,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActiveLeaveRequestsTab(tab));
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        staffType: "1",
        currentPage: 1,
        siteId: "",
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      GetSiteList(tab);
    } else {
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      setPageStates((prev) => ({
        ...prev,
        staffType: "0",
        currentPage: 1,
        siteId: filterDetails?.siteId,
      }));
      GetSiteList(tab);
    }
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const sortHandler = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(!type && { leaveType: data?.leaveType }),
      ...(!type && { leaveStatus: data?.leaveStatus }),
      ...(type == "site" && { siteId: data?.site }),
      ...(type && { officeType: data?.office }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type == "site" && { siteId: data?.site }),
      })
    );
  };

  const handleView = (data) => {
    navigate(`${RoutesLink?.leave_detail}/${data?.id}`, {
      state: { type: "request" },
    });
  };

  const TableHeadingOffice = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    { value: "employeeDept", label: "Emp. Dept." },
    { value: "officeName", label: "Office" },
    { value: "leaveType", label: "Leave Type" },
    { value: "appliedOn", label: "Applied On" },
    { value: "fromDate", label: "From" },
    { value: "toDate", label: "To" },
    { value: "days", label: "Days" },
    { value: "leaveStatus", label: "Status" },
  ];
  const TableHeadingSite = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    { value: "employeeDept", label: "Emp. Dept." },
    { value: "siteName", label: "Site" },
    { value: "leaveType", label: "Leave Type" },
    { value: "appliedOn", label: "Applied On" },
    { value: "fromDate", label: "From" },
    { value: "toDate", label: "To" },
    { value: "days", label: "Days" },
    { value: "leaveStatus", label: "Status" },
  ];

  const getLeaveSetting = () => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_leave_setting + "?all=true";
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          leaveTypeList: res?.data,
        }));
      }
    });
  };

  const GetSiteList = (type, companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl?.get_site +
        `?type=${type === 2 ? "O%26M" : "office"}` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.id,
              label: item?.name,
            }));
            if (type == 2) {
              const siteId = response.data?.site?.some(
                (item) => item?.id == filterDetails?.siteId
              );
              setPageStates((prev) => ({
                ...prev,
                ...(siteId ? { isInitial: false } : { siteId: "" }),
                siteList: formattedData || [],
              }));
            } else {
              setPageStates((prev) => ({
                ...prev,
                officeList: response?.data?.site || [],
              }));
            }

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: handleView,
    },
  ];

  const sortList = {
    leaveStatus: [
      { value: "", label: "Select Leave Status" },
      { value: 1, label: "Approved" },
      { value: 0, label: "Pending" },
      { value: 2, label: "Rejected" },
    ],
    leaveType: pageStates?.leaveTypeList,
    ...(ActiveTab === 1
      ? { office: pageStates?.officeList }
      : { site: pageStates.siteList }),
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Leave Requests"}
          dateChangeHandler={dateChangeHandler}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          <NavItem className="nav-item">
            <NavLink
              className={
                ActiveTab === 1
                  ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                  : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(1)}
            >
              Office Leave Requests
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === 2
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(2)}
            >
              Site Leave Requests
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={ActiveTab}>
          <TabPane tabId={1}>
            <Fade in={ActiveTab === 1} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    exportBtn={true}
                    filterArray={sortList}
                    sortHandler={sortHandler}
                    handleData={sortHandler}
                    handleSearch={handleSearchChange}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    tableDataForExport={pageStates?.leaveList}
                    exportFileName={"Office_Staff_Leave_Request_Data"}
                    exportColumns={[
                      "employeeCode",
                      "employeeName",
                      "employeeDept",
                      "officeName",
                      "leaveType",
                      "appliedOn",
                      "fromDate",
                      "toDate",
                      "days",
                      "leaveStatus",
                    ]}
                  />
                  <CommonTable
                    TableHeading={TableHeadingOffice}
                    TableData={pageStates?.leaveList}
                    ActionData={ActionData}
                    currentPage={pageStates?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={pageStates?.totalPages}
                    count={pageStates?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={pageStates.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={2}>
            <Fade in={ActiveTab === 2} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    exportBtn={true}
                    filterArray={sortList}
                    sortHandler={sortHandler}
                    handleData={sortHandler}
                    handleSearch={handleSearchChange}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    tableDataForExport={pageStates?.leaveList}
                    exportFileName={"Site_Staff_Leave_Request_Data"}
                    getSite={(companyId, searchQuery) =>
                      GetSiteList(2, companyId, searchQuery)
                    }
                    pageStates={pageStates}
                    exportColumns={[
                      "employeeCode",
                      "employeeName",
                      "employeeDept",
                      "siteName",
                      "leaveType",
                      "appliedOn",
                      "fromDate",
                      "toDate",
                      "days",
                      "leaveStatus",
                    ]}
                  />
                  <CommonTable
                    TableHeading={TableHeadingSite}
                    TableData={pageStates?.leaveList}
                    ActionData={ActionData}
                    currentPage={pageStates?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={pageStates?.totalPages}
                    count={pageStates?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={pageStates.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
}
